import { createAction, props } from '@ngrx/store';
import { CrossSelling } from '../../models/form-state.model';

export const patchQuestions = createAction(
  '[CrossSelling] Patch Questions',
  props<{ payload: Partial<CrossSelling> }>()
);

export const init = createAction('[Init]');
